<template>
  <div id="wizard-wrapper">
    <div class="config-wrapper">
      <button id="reset"
              @click="reset('all')">
        {{ config.buttonLabel | uppercase }}
      </button>
    </div>

    <form id="studyTypeForm">
      <h3>{{ config.studyTypeHeader }}</h3>
      <fieldset>
        <div v-for="(studyType,key) in config.studyTypes" :key="key">
          <input type="radio"
                 :id="key"
                 name="typ"
                 :value="key"
                 :checked="key===selectedStudyType"
                 @click="applyStudyType($event.target.value)">
          <label :for="key">{{ studyType }}</label>
        </div>
      </fieldset>
      <h3>{{ config.studyCourseHeader }}</h3>
      <div class="selector-wrapper">
        <select
            v-model="selectedStudycourse"
            id="studiengang"
            @change="applyStudyCourse($event.target.value)">
          <option disabled value="" :selected="true">{{ config.studyCoursePlaceHolder }}</option>
          <option
              v-for="(course, index) in studyCourses"
              :key="index"
              :value="course.id">
            {{ course.name }}
          </option>
        </select>
      </div>
    </form>

    <form v-if="selectedStudyType !== ''" id="citizenshipForm">
      <h3>{{ config.citizenshipHeader }}</h3>
      <fieldset>
        <div>
          <input
              type="radio"
              id="ger"
              name="staatsbuergerschaft"
              value="ger"
              v-model="checkedCitizenship"
              @click="applyCitizenship($event.target.value)">
          <label for="ger">
            <div class="width-restrictor">
              <div class="flag-wrapper">
                <img src="../../assets/germany-flag.svg" alt="germany flag">
              </div>
              {{ config.citizenshipOptions['ger'] }}
            </div>
          </label>
        </div>
        <div v-if="selectedStudyType !== 'baNC'">
          <input
              type="radio"
              id="notGer"
              name="staatsbuergerschaft"
              value="notGer"
              v-model="checkedCitizenship"
              @click="applyCitizenship($event.target.value)">
          <label for="notGer">
            <div class="width-restrictor">
              <div class="flag-wrapper">
                <img src="../../assets/germany-flag.svg" alt="germany flag crossed">
                <div class="crossed-line"></div>
              </div>
              {{ config.citizenshipOptions['notGer'] }}
            </div>
          </label>
        </div>
        <div v-if="selectedStudyType === 'baNC'">
          <input
              type="radio"
              id="eu"
              name="staatsbuergerschaft"
              value="eu"
              v-model="checkedCitizenship"
              @click="applyCitizenship($event.target.value)">
          <label for="eu">
            <div class="width-restrictor">
              <div class="flag-wrapper">
                <img src="../../assets/europe-flag.svg" alt="europe flag">
              </div>
              {{ config.citizenshipOptions['eu'] }}
            </div>
          </label>
        </div>
        <div v-if="selectedStudyType === 'baNC'">
          <input
              type="radio"
              id="notEu"
              name="staatsbuergerschaft"
              value="notEu"
              v-model="checkedCitizenship"
              @click="applyCitizenship($event.target.value)">
          <label for="notEu">
            <div class="width-restrictor">
              <div class="flag-wrapper">
                <img src="../../assets/europe-flag.svg" alt="europe flag crossed">
                <div class="crossed-line"></div>
              </div>
              {{ config.citizenshipOptions['notEu'] }}
            </div>
          </label>
        </div>
      </fieldset>
    </form>

    <form v-if="filteredQualifications.length !== 0" id="qualificationForm">
      <fieldset>
        <div v-for="(qualification, index) in filteredQualifications" :key="qualification.id">
          <input
              type="radio"
              :id="qualification.id"
              name="qualification"
              :value="index"
              v-model="checkedQualification"
              @click="showResults(qualification.id)">
          <label :for="qualification.id">
            {{ qualification.description }}
          </label>
        </div>
      </fieldset>
    </form>

    <section v-if="results" id="result">
      <div id="pointOfContacts">
        <h3>{{ config.resultHeader }}</h3>
        <ul>
          <li v-for="(res, index) in results"
              :key="index">
            <p class="link-wrapper" v-html="res.poc"></p>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import * as defaultConf from '../fallbackData/config.yaml'

import ImporterService from "../services/importer.service";

export default {
  name: 'thk-wizard',
  props: {
    defaultLang: {
      type: String,
      default: 'de_DE'
    },
    extStudyType: {
      type: String,
      default: ''
    },
    extStudyCourseId: {
      type: String,
      default: ''
    },
    configsrc: {
      type: String,
      default: './config.yaml'
    },
    studycoursesrc: {
      type: String,
      default: './studyCourses.csv'
    },
    qualificationsrc: {
      type: String,
      default: './qualifications.yaml'
    },
    resultsrc: {
      type: String,
      default: './results.yaml'
    },
    graphsrc: {
      type: String,
      default: './graph.yaml'
    }
  },
  data() {
    const importService = new ImporterService();
    return {

      importService,

      config: {
        buttonLabel: '',
        studyTypeHeader: '',
        studyTypes: {
          baWoNC: '',
          baNC: '',
          ma: ''
        },
        studyCourseHeader: '',
        studyCoursePlaceHolder: '',
        citizenshipHeader: '',
        citizenshipOptions: {
          ger: '',
          notGer: '',
          eu: '',
          notEu: ''
        },
        qualificationHeader: '',
        resultHeader: '',
        documentHeader: '',
        noteHeader: ''
      },
      selectedLang: '',

      fetchedData: {
        studyCourses: [],
        qualifications: [],
        results: [],
      },

      studyCourses: [],
      relations: [],

      selectedStudyType: '',
      selectedStudycourse: '',
      selectedCitID: '',


      filteredQualifications: [],

      checkedCitizenship: false,
      checkedQualification: false,

      results: null,

      disabled: true,
    }
  },
  created() {
    this.selectedLang = this.defaultLang;
    this.setLang(this.selectedLang);
  },
  async mounted() {
    // console.log(`initialized with study course list: ${this.studycoursesrc},
    //              qualification list: ${this.qualificationsrc},
    //              results list: ${this.resultsrc} and
    //              graph ${this.graphsrc}`
    // );

    // get study courses
    this.importService.csvHandler(this.studycoursesrc)
        .then(studyCourses => {
          this.fetchedData.studyCourses = this.mapStudyCourses(studyCourses);
          this.studyCourses = this.fetchedData.studyCourses;
        })
        .then(async () => {
          if (this.extStudyType) {
            await this.applyStudyType(this.extStudyType);
          }
          if (this.extStudyCourseId) {
            this.selectedStudycourse = this.extStudyCourseId;
            this.applyStudyCourse(this.extStudyCourseId);
          }
        });

    // get qualifications
    this.importService.yamlHandler(this.qualificationsrc)
        .then(async q => {
          this.fetchedData.qualifications = q.qualifications
        });

    // get results
    this.importService.yamlHandler(this.resultsrc)
        .then(r => this.fetchedData.results = r.results);

    // get relations between tables
    this.importService.yamlHandler(this.graphsrc)
        .then(g => {
          this.relations = g;
        });
  },
  methods: {

    setLang(value) {
      this.importService.yamlHandler(this.configsrc).then(c => {
        const foundConf = c.configs[value];
        if (foundConf) {
          this.mapConfig(foundConf, defaultConf, this.config)
        } else {
          this.config = defaultConf;
        }
      }).catch(() => {
        console.log('setting fallback config');
        this.config = defaultConf;
      })
    },

    // maps selected config to local config and use fallback values if
    // selected config has no values.
    mapConfig(selected, fallback, target) {
      const keys = Object.keys(fallback);
      keys.forEach(key => {
        const obj = fallback[key];
        if (typeof obj === 'object' && selected[key]) {
          this.mapConfig(selected[key], fallback[key], target[key]);
          return;
        }
        target[key] = selected[key] || fallback[key];
      })
    },

    mapStudyCourses(courses) {
      // console.log(courses);
      return courses.data.map(course => {
        const studyCourse = {
          id: '',
          type: '',
          name: ''
        }
        if (!(course.Studiengang && course.Studiengangsart)) {
          return;
        }
        studyCourse.id = course.Studiengang;
        studyCourse.name = course.Studiengang;

        if (course.Studiengangsart === 'Master') {
          studyCourse.type = 'ma';
          return studyCourse;
        }

        if (course.Zulassung?.toLowerCase() === 'frei') {
          studyCourse.type = 'baWoNC';
        } else {
          studyCourse.type = 'baNC';
        }
        return studyCourse;

      });
    },

    mapQualifications(qualifications) {

      return qualifications.map(qualification => {
        const quali = {
          id: '',
          description: '',
        }
        if (!(qualification.id)) {
          return;
        }
        quali.id = qualification.id;
        quali.description = qualification[this.selectedLang].description || qualification[this.defaultLang].description;

        return quali;
      });
    },

    // sets study type value and resets upcoming steps in form;
    // filters study courses by study type
    async applyStudyType(value, setByUser = true) {
      if (this.selectedStudyType === value) {
        return;
      }
      if (setByUser) {
        this.selectedStudycourse = '';
      }
      this.reset('studyType')
      this.studyCourses = this.fetchedData.studyCourses.filter(c => c.type === value);
      this.selectedStudyType = value;
    },

    // sets study type value by chosen study course
    applyStudyCourse(value) {
      const selectedStudyCourse = this.fetchedData.studyCourses.find(c => c.id === value);
      if (selectedStudyCourse.type !== this.selectedStudyType) {
        this.applyStudyType(selectedStudyCourse.type, false)
      }
    },

    // sets citizenship id and resets upcoming steps in form;
    // filters qualification list by cit id
    applyCitizenship(value) {
      this.reset('citizenship')
      this.selectedCitID = value;

      const qualIDs = this.relations.qualificationRelations.filter(
          relation => relation.typeIDs.includes(this.selectedStudyType) && relation.citIDs.includes(this.selectedCitID)
      ).map(relation => relation.qualID);

      const qualifications = []

      qualIDs.forEach(id => {
        qualifications.push(
            this.fetchedData.qualifications.find(qualification => qualification.id === id)
        )
      })

      if (qualifications.length === 0) {
        this.showResults(0, true);
      } else {
        this.filteredQualifications = this.mapQualifications(qualifications);
      }
    },

    showResults(qualificationID, withoutQual = false) {
      let resRelations;
      if (withoutQual) {
        resRelations = this.relations.resultRelations.filter(
            res => res.typeIDs.includes(this.selectedStudyType)
                && res.citIDs.includes(this.selectedCitID)
        )
      } else {
        resRelations = this.relations.resultRelations.filter(
            res => res.typeIDs.includes(this.selectedStudyType)
                && res.citIDs.includes(this.selectedCitID)
                && res.qualIDs.includes(qualificationID)
        )
      }

      const results = []
      this.results = []
      resRelations.forEach(result => {
        results.push(...this.fetchedData.results.filter(res => res.id === result.resID));
      })
      this.results = results.map(r => {
        return {
          poc: r[this.selectedLang].description || r[this.defaultLang].description,
        }
      });
    },

    // resets form values from desired progress step
    reset(fromProgress) {
      switch (fromProgress) {
        case 'all':
          this.selectedStudyType = '';
          this.studyCourses = this.fetchedData.studyCourses;
          this.selectedStudycourse = '';

          this.checkedCitizenship = false;
          this.selectedCitID = ''

          this.filteredQualifications = [];
          this.checkedQualification = false;

          this.results = null;
          break;
        case 'studyType':
          this.checkedCitizenship = false;
          this.selectedCitID = ''

          this.filteredQualifications = [];
          this.checkedQualification = false;

          this.results = null;
          break;
        case 'citizenship':
          this.filteredQualifications = [];
          this.checkedQualification = false;

          this.results = null;
          break;
        default:
          break;
      }
    },

  },
  filters: {
    uppercase: function (v) {
      if (v) {
        return v.toUpperCase();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#wizard-wrapper {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


.config-wrapper {
  margin-block: 1em;
  display: flex;
  justify-content: end;

}

.config-wrapper #language-selector {
  width: 3.5rem;
  margin-inline: 0.5em;
  height: 2em;
  color: #646464;
  border: 1px solid lightgray;
}

.config-wrapper button {
  font-family: inherit;
  background-color: white;
  color: #646464;
  border: 1px solid lightgray;
  border-radius: 6px;
  width: fit-content;
  height: 3.5em;
  padding-inline: 2em;
}

.config-wrapper button:hover,
.config-wrapper #language-selector:hover {
  cursor: pointer;
  background-color: #f6f6f6;
  color: #424242;
  border-color: #c2c2c2;
}

.config-wrapper #language-selector:hover {
  background-color: white;
}

form fieldset {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  border: none;
}


@media (max-width: 768px) {
  form fieldset {
    flex-direction: column;
  }
}

#qualificationForm fieldset {
  display: block;
}

fieldset div {
  display: flex;
  align-items: center;
}

#qualificationForm fieldset div {
  margin-block: 0.5em;
}

/*#qualificationForm fieldset div:hover{*/
/*  background-color: #f6f6f6;*/
/*}*/

form fieldset div input {
  margin-right: 1em;
}

form div input {
  margin: 0.25rem;
}

form div input:hover,
form div label:hover {
  cursor: pointer;
}

.width-restrictor {
  max-width: 450px;
}

@media (max-width: 768px) {
  .width-restrictor {
    max-width: 700px;
  }
}

.selector-wrapper {
  padding-inline: 1em;
}

select {
  font-family: inherit;
  font-size: 1rem;
  width: 100%;
  height: 3rem;
  border-radius: 6px;
}

.flag-wrapper {
  width: 25px;
  height: 25px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.flag-wrapper img {
  max-width: 1.2em;
  max-height: 0.9em;
  width: auto;
  height: auto;
}

.crossed-line {
  position: absolute;
  width: 1.8em;
  height: 0.125em;
  z-index: 1;
  background-color: red;
  transform: rotate(45deg);
}

li {
  margin-bottom: 1em;
}

.link-wrapper >>> a,
.link-wrapper >>> a:hover,
.link-wrapper >>> a:visited,
.link-wrapper >>> a:link,
.link-wrapper >>> a:active {
  text-decoration: underline;
  color: inherit;
}

:host-context(#content) .link-wrapper >>> .internal,
:host-context(#content) .link-wrapper >>> .external {
  padding-left: 1em;

  background-size: 12px 12px;
  background-position: left 7px;
  background-repeat: no-repeat;
  margin-left: 0.2em;
}

:host-context(#content) .link-wrapper >>> .internal {
  background-image: url(../../assets/link-intern.svg);
}

:host-context(#content) .link-wrapper >>> .external {
  background-image: url(../../assets/link-extern.svg);
}


:host-context(#content) .link-wrapper >>> .internal:hover,
:host-context(#content) .link-wrapper >>> .external:hover {
  background-color: #e0e0e0;
}

</style>
